module.exports = __webpack_public_path__ + "static/antd-table-truncate-28d43245e4ecf28004fb370f138883b7.png";